import React from 'react';
import FlexicoUpload from './FlexicoUploadComponent';
import FlexicoUploadComponent from './FlexicoUploadComponent';

export default (props) => {
    return <FlexicoUploadComponent location={props.location} />;
}
